import React, { useState } from 'react'
import { Breadcrumbs, DynamicEntityIndex } from '@reactiveonline/reactive_admin_shared-packages'
import { dynamicTableItemRenderer } from '@reactiveonline/reactive_admin_shared-packages/utils'
import GlobalImports from '../shared/GlobalImports'
import AffiliateLinksDrawer from './AffiliateLinksDrawer'

export default function Index({
  appProps, affiliateCodes, breadcrumbs, entityPath, icon, initialTotalPages, listColumns, organizationsPath, selectedColumns, totalCount
}) {
  const [affiliateCodeLinksModalItem, setAffiliateCodeLinksModalItem] = useState(null)
  const actions = [
    {
      icon: 'fa-link',
      onClick: (event, item) => {
        event.preventDefault()
        setAffiliateCodeLinksModalItem(item)
      }
    }
  ]

  const itemRenderer = (item, columns) => (
    <>
      { columns.map(column => {
        if (column.label === 'code') {
          return (
            <div key={ column.label } className='item flex-1'>
              { item[column.label] }
            </div>
          )
        }

        if (column.label === 'organization') {
          return (
            <div key={ column.label } className='item flex-1'>
              <a href={ `${ organizationsPath }/${ item.organizationApiUid }/edit` }>
                { item.organization }
              </a>
            </div>
          )
        }

        if (column.label === 'active') {
          return (
            <div key={ column.label } className='item flex-1'>
              <i className={ `fa-light ${ item.active ? 'fa-circle-check' : 'fa-circle-xmark' }` }/>
            </div>
          )
        }

        return dynamicTableItemRenderer(item, column)
      })}
    </>
  )

  return (
    <>
      <div className='page-wrapper-header'>
        <div>
          <div className='page-header'>
            <i className={ `fa-light ${ icon }` }/>
            <h1 className='page-header-title'>
              { Partners.translations.affiliateCode.plural }
              <span className='m-l-10'>({ totalCount })</span>
            </h1>
          </div>

          <Breadcrumbs
            breadcrumbs={ breadcrumbs }
            wrapperHeader={ false }
          />
        </div>
      </div>

      <DynamicEntityIndex
        initialItems={ affiliateCodes }
        initialTotalPages={ initialTotalPages }
        disableDelete
        entity={ 'affiliate_codes' }
        tabs={ [] }
        tableHeadings={ selectedColumns }
        disableCustomization={ true }
        itemRenderer={ itemRenderer }
        itemsPath={ entityPath }
        icon={ icon }
        noResourcesTitle={ Partners.translations.affiliateCode.no_affiliate_codes }
        listColumns={ listColumns }
        columnTranslations={ Partners.translations.columns }
        actions={ actions }
      />

      <AffiliateLinksDrawer
        affiliateCode={ affiliateCodeLinksModalItem }
        closeDrawer={ () => setAffiliateCodeLinksModalItem(null) }
      />

      <GlobalImports appProps={ appProps } />
    </>
  )
}
